import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  TriggersTemplatePagesContainer,
  Content,
  TableContainer,
} from "./TriggersLogsPage.styled";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../../components/Footer";
import { Table, Alert, Tag } from "@ann/web-components";
import FilterBarLog from "../../components/FilterBarLogs/FilterBarLog";
import LogHeader from "../../components/LogHeader/LogHeader";
import { useTriggersLogs } from "../../context/TriggersLogsContext";
import { useAlert } from "../../hooks/useAlert";
import Header from "../../components/Header";

const TriggersLogsPage = () => {
  const { uuid } = useParams();
  const { alert, showAlert, hideAlert } = useAlert();
  
  const {
    filteredLogs,
    loading,
    pagination,
    mode,
    loadTriggerLogs,
    setMode,
    setPage
  } = useTriggersLogs();

  useEffect(() => {
    loadTriggerLogs();
  }, [loadTriggerLogs]);

  const headers = [
    { value: "name", label: "Workflow Name" },
    { value: "details", label: "Detail" },
    { value: "modifiedBy", label: "Modified By" },
    { value: "action", label: "Action" },
    { value: "status", label: "Status" },
    { value: "dateOfChange", label: "Timestamp" },
  ];

  const tableData = filteredLogs.map(log => ({
    ...log,
    status: <Tag text={log.status ? "On" : "Off"} color={log.status ? "success" : "error"} />,
    dateOfChange: new Date(log.dateOfChange).toLocaleString(),
  }));

  const showTable = tableData.length > 0;

  return (
    <>
      {alert && (
        <Alert
          title={alert.title}
          description={alert.message}
          severity={alert.severity}
          width={"692px"}
          top={"61px"}
          right={"16px"}
          onClose={hideAlert}
        />
      )}
      <TriggersTemplatePagesContainer>
        <Content>
          <Breadcrumb />
          <Header />

          <FilterBarLog mode={mode} setMode={setMode} />

          <TableContainer>
            {showTable && (
              <Table 
                headers={headers} 
                data={tableData} 
                mode={mode} 
                loading={loading}
                showActions={false}                
              />
            )}
          </TableContainer>
        </Content>
      </TriggersTemplatePagesContainer>

      <Footer
        currentPage={pagination.currentPage}
        totalPages={pagination.totalPages}
        itemsPerPage={pagination.itemsPerPage}
        totalItems={pagination.totalItems}
        onPageChange={setPage}
        disabled={loading}
      />
    </>
  );
};

export default TriggersLogsPage;
